import React from 'react';
import {
  Avatar,
  Typography,
  Button,
  IconButton,
  Tooltip,
} from '@mui/material';
import ToggleButton from '@mui/lab/ToggleButton';
import SettingsIcon from '@mui/icons-material/Settings';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

const LibraryProfileBar = ({
  person,
  isOwner,
  isFollowed,
  isFriend,
  ownerUsernameTooltip,
  onLoadFollowings,
  onLoadFollowers,
  onFollowToggle,
  onOpenSidebar,
  showMenuButton,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <div className="library-profile-bar">
      {showMenuButton ? (
        <IconButton
          className="library-mobile-menu-btn"
          aria-label="Open navigation"
          onClick={onOpenSidebar}
          size="small"
        >
          <MenuIcon />
        </IconButton>
      ) : null}
      <Avatar src={person.profileImageUrl} className="library-profile-avatar" />
      <div className="library-profile-identity">
        <Tooltip
          title={ownerUsernameTooltip}
          arrow
          placement="bottom"
          disableHoverListener={!isOwner}
          disableFocusListener={!isOwner}
          disableTouchListener={!isOwner}
        >
          <Typography className="library-profile-username" component="span">
            @{person.username}
          </Typography>
        </Tooltip>
        {isOwner ? (
          <IconButton
            size="small"
            aria-label="Settings"
            onClick={() => navigate('/settings')}
          >
            <SettingsIcon fontSize="small" />
          </IconButton>
        ) : null}
      </div>
      {!isOwner ? (
        <ToggleButton
          color="secondary"
          value="check"
          selected={isFollowed || isFriend}
          onChange={() => {
            if (onFollowToggle) onFollowToggle();
            else dispatch({ type: 'OPEN_SIGN_$' });
          }}
          size="small"
        >
          {!isFollowed && !isFriend ? 'Add' : 'Undo'}
        </ToggleButton>
      ) : null}
      <div className="library-profile-stats">
        <Button
          onClick={onLoadFollowings}
          variant="outlined"
          className="library-stat-btn"
          size="small"
        >
          {person.followingCount} following
        </Button>
        <Button
          onClick={onLoadFollowers}
          variant="outlined"
          className="library-stat-btn"
          size="small"
        >
          {person.followerCount} followers
        </Button>
      </div>
      {person.description ? (
        <Typography
          variant="body2"
          sx={{ width: '100%', color: '#6b7280', fontSize: '0.85rem', mt: 0.5 }}
        >
          {person.description}
        </Typography>
      ) : null}
    </div>
  );
};

export default LibraryProfileBar;
